import axios from 'axios';

export const normalizeResponse = (acc) => {
  const { data, meta } = acc.data;

  if (meta) {
    acc.data = data;
    acc.meta = meta;
  }

  return Promise.resolve(acc);
};

/* istanbul ignore next */
(() => {
  axios.interceptors.response.use(normalizeResponse, err => Promise.reject(err));
})();
